import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputBase,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { useRoles } from 'hooks'

/**
 * Componente requiere el uso de react-hook-form para generar
 * el prop control.
 * @param {*} _props
 * @returns {JSX}
 */
const Input = forwardRef((_props, ref) => {
  const {
    control, // Prop control de react-hook-form
    label = '', // texto del label
    name = '', // nombre del campo para manejo de datos
    type = 'text', // tipo de campo
    defaultValue = '', // valor por defecto
    helperText = '', // texto de ayuda
    validation = {}, // validaciónes
    autoFocus = false, // autofocus
    options = null, // opciones para el select
    placeholder = '', // placeholder para el input
    errors,
    ...inputProps
  } = _props

  const hasError = Boolean(errors?.message)

  const isRequired = Boolean(validation?.required) ? true : null

  const isRolesSelect = type === 'rolesSelect'

  const [, { isLoadingRoles, rolesOptions }] = useRoles(!isRolesSelect)

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={validation}
      render={({ field, fieldState: { isTouched, isDirty, error } }) => (
        <FormControl fullWidth>
          {Boolean(label) && (
            <FormLabel error={hasError} required={isRequired}>
              {label}
            </FormLabel>
          )}
          {['text', 'number', 'email', 'password'].includes(type) && (
            <InputBase
              {...field}
              autoFocus={autoFocus}
              type={type === 'email' ? 'text' : type}
              {...inputProps}
              error={hasError}
              inputRef={ref}
              placeholder={placeholder}
            />
          )}
          {type === 'select' && (
            <Select
              {...field}
              autoFocus={autoFocus}
              type={type}
              {...inputProps}
              error={hasError}
              inputRef={ref}
              input={<InputBase />}
            >
              <MenuItem disabled value="">
                {Boolean(placeholder) || 'Seleccione una opción'}
              </MenuItem>
              {options.map((option, index) => (
                <MenuItem
                  key={index}
                  value={option.value}
                  disabled={option.disabled || null}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          )}
          {type === 'rolesSelect' && (
            <Select
              {...field}
              autoFocus={autoFocus}
              type={type}
              {...inputProps}
              error={hasError}
              inputRef={ref}
              input={<InputBase />}
            >
              {isRolesSelect && isLoadingRoles && (
                <MenuItem disabled value="">
                  Cargando roles...
                </MenuItem>
              )}
              {!isLoadingRoles && (
                <MenuItem disabled value="">
                  {Boolean(placeholder) || 'Seleccione una opción'}
                </MenuItem>
              )}
              {isRolesSelect &&
                !isLoadingRoles &&
                rolesOptions.map((option, index) => (
                  <MenuItem key={index} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
            </Select>
          )}
          {type === 'date' && (
            <DesktopDatePicker
              {...field}
              {...inputProps}
              disableFuture={true}
              fullWidth={true}
              inputFormat="dd-MM-yyyy"
              renderInput={({ inputRef, inputProps, InputProps }) => (
                <InputBase
                  fullWidth={true}
                  ref={inputRef}
                  {...inputProps}
                  endAdornment={
                    <InputAdornment position="end">
                      {InputProps?.endAdornment}
                    </InputAdornment>
                  }
                />
              )}
              //renderInput={(params) => <InputBase {...params} />}
            />
          )}
          <FormHelperText error={hasError}>
            {hasError ? errors?.message : helperText}
          </FormHelperText>
        </FormControl>
      )}
    />
  )
})

export default Input
